// extracted by mini-css-extract-plugin
export var icon = "Q0K3G";
export var root = "FLwLv";